module.exports = __webpack_public_path__ + "static/img/brees-2012-slide-2.0ac02ae.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brees-2012-slide-2.jpg
// module id = nVbO
// module chunks = 1